import { render, staticRenderFns } from "./ProduceInfo.vue?vue&type=template&id=042fbdee&scoped=true&"
import script from "./ProduceInfo.vue?vue&type=script&lang=js&"
export * from "./ProduceInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProduceInfo.vue?vue&type=style&index=0&id=042fbdee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042fbdee",
  null
  
)

export default component.exports